import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

import { Api } from '@/lib/api';

import { UserApi } from '../api';
import { loginSchema } from '../schemas';
import { useRouter } from 'next/navigation';
import { useUserSelfQuery } from './users';
import { setEncryptedItem, getEncryptedItem, removeEncryptedItem } from '@/utils/LocalStorageHelper';

export function useLoginMutation() {
  const router = useRouter();
  return useMutation({
    mutationFn: (data: z.infer<typeof loginSchema>) => UserApi.login(data),
    onSuccess: (response) => {
      // TODO: Token süresini kontrol et
      const { token,refreshToken,expires } = response.data.data;
      setEncryptedItem('companies', JSON.stringify(response.data.data.companies.map(company => ({companyId: company.id, name:company.name,posCount:company.posCount}))));
      Api.setToken(token, refreshToken, expires);   
      
      
      //localStorage.setItem('companyId', response.data.data.companies[0].id.toString());   
      //router.push('/dashboard'); 
     
    },
    onError: () => {
      removeEncryptedItem('userId');
    },
  });
}
